import React from 'react';
import OrderSummary from '../../new-order-components/OrderSummary';

const PurchaseSummary = ({ items = [], totals = {} }) => {
  console.log("PurchaseSummary received totals:", totals);
  console.log("PurchaseSummary totals keys:", Object.keys(totals));
  console.log("PurchaseSummary individual values:", {
    subtotalHT: totals.subtotalHT,
    tva: totals.tva,
    remise: totals.remise,
    total: totals.total
  });
  
  // Convert purchase totals to OrderSummary format (keep the original property names)
  const purchaseTotals = {
    subtotalHT: totals.subtotalHT || 0,      // Keep as subtotalHT (OrderSummary expects this)
    tva: totals.tva || 0,                    // Keep as tva (OrderSummary expects this)
    remise: totals.remise || 0,              // Keep as remise (OrderSummary expects this)
    total: totals.total || 0,                // Keep as total
    deliveryFee: 0                           // Add deliveryFee
  };

  console.log("PurchaseSummary converted totals for OrderSummary:", purchaseTotals);
  console.log("PurchaseSummary converted individual values:", {
    subtotalHT: purchaseTotals.subtotalHT,
    tva: purchaseTotals.tva,
    remise: purchaseTotals.remise,
    total: purchaseTotals.total
  });
  
  return (
    <OrderSummary
      items={items}
      totals={purchaseTotals}
      // No children to avoid rendering the status selector
    />
  );
};

export default PurchaseSummary;